import React from 'react';
// Components
import AllMerch from './AllMerch/AllMerch';

const ManageMerch = (): JSX.Element => {
  return <AllMerch />;
};

export default ManageMerch;
